export default "__VITE_ASSET__CdRU8WuJ__"